import { makeStyles } from "@mui/styles"
import { fontFamilies } from "@fedsim/constants"

export const useStyles = makeStyles(() => {
  const root = {
    display: "flex",
    minHeight: "100vh",
    flexDirection: "column",
    fontFamily: fontFamilies.bodyFont,
    maxWidth: "none !important",
  }

  return {
    root,
    title: {
      fontVariant: "small-caps",
      cursor: "pointer",
    },
    content: {
      "@media (orientation: landscape)": {
        marginLeft: "env(safe-area-inset-left)",
      },
    },
  }
})
